export default __webpack_public_path__ + "static/media/Baishan.d417937d.jpg";